import { useState } from 'react'
import { Box, Stack, Typography } from '@mui/material'

// TinyFish live preview is read-only and its stream URL can expire once the run
// ends; on an iframe load error we fall back to a quiet "ended" state.
export default function BrowserPreview({ block }) {
  const [ended, setEnded] = useState(false)
  const streamingUrl = block?.streamingUrl
  if (!streamingUrl) return null

  return (
    <Box
      sx={{
        borderRadius: 'var(--app-radius-md)',
        border: 'none',
        bgcolor: 'var(--app-bg-hover)',
        overflow: 'hidden',
        maxWidth: 640,
      }}
    >
      <Stack
        direction="row"
        sx={{ gap: 0.75, alignItems: 'center', px: 1.25, py: 0.75 }}
      >
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            bgcolor: ended ? 'var(--app-text-tertiary, #8a8a8a)' : '#2ecc71',
          }}
        />
        <Typography sx={{ fontSize: 12, color: 'var(--app-text-secondary)' }}>
          {ended ? 'Browser preview ended' : 'Live browser preview · read-only'}
        </Typography>
      </Stack>
      {ended ? null : (
        <Box
          component="iframe"
          src={streamingUrl}
          title="Live browser preview"
          onError={() => setEnded(true)}
          sandbox="allow-scripts allow-same-origin"
          sx={{ width: '100%', height: 360, border: 0, display: 'block' }}
        />
      )}
    </Box>
  )
}
